import { Directive, ElementRef, Renderer2, HostListener, Inject, Output, EventEmitter, Input, forwardRef, DOCUMENT } from '@angular/core';

import { MANGLISH_LOOKUP } from '@otas/utils/directives/extras/manglish-layout';
import { IpcUtilService } from '@otas/utils/directives/helper/ipc-util.service';
import { CurrentUser } from '@otas/model/current-user';
import { AppConstants } from '../../../app/app.constants';
import * as _ from 'underscore';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input:not([type=text])[type=other],[manglishText]',
    exportAs: 'manglishConverter',
    standalone: false
})
export class ManglishConverterDirective {

  pattern: any;
  patternStart: any;
  tabCount: number = 1;
  charMap: any;
  @Output() minput = new EventEmitter<string>();
  @Input() keyboard = 'english';
  @Output() patternOutput = new EventEmitter<string>();
  @Output() blurEvent = new EventEmitter();
  disabled: boolean;

  constructor(@Inject(DOCUMENT) private document: any, private IPCutil: IpcUtilService,
    public elementRef: ElementRef, private _renderer: Renderer2) {
    const user: CurrentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
    if (user?.typingLanguage === 'MALAYALAM') {
      this.keyboard = 'malayalam';
    } else if (user?.typingLanguage === 'MALAYALAM') {
      this.keyboard = 'english';
    } else if (user?.typingLanguage === 'MANGLISH') {
      this.keyboard = 'manglish';
    }
  }

  @HostListener('input', ['$event'])
  oninput(event: Event) {
    this.minput.emit((event.target as HTMLInputElement).value);
  }

  @HostListener('blur', ['$event'])
  onblur(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    // Get the closest auto-complete container (if any)
    const autoCompleteContainer = this.elementRef.nativeElement.closest('app-auto-complete');
    // Check if the related target is inside the same container
    if (relatedTarget && autoCompleteContainer && autoCompleteContainer.contains(relatedTarget)) {
      event.preventDefault();
      event.stopPropagation();
      // if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      // }
    }
    if (!this.elementRef.nativeElement.value) {
      this.pattern = null;
      this.patternOutput.emit(null);
    }
    setTimeout(() => {
      if (this.document.activeElement !== this.elementRef.nativeElement) {
        this.pattern = null;
        this.patternOutput.emit(null);
      }
    }, 0);
    setTimeout(() => {
      this.blurEvent.emit();
    }, 20);
  }

  @HostListener('keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (event.key === 'F6') {
      event.preventDefault();
      this.keyboard = this.keyboard === 'manglish' ? 'english' : 'manglish';
      const user: CurrentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
      if (this.keyboard === 'malayalam' || this.keyboard === 'manglish') {
        this.keyboard = 'english';
      } else {
        this.keyboard = user?.typingLanguage?.toLowerCase() || 'english';
      }
    }
    const node = this.elementRef.nativeElement;
    const nodeLen = node.value.length;
    const startPos = node.selectionStart;
    const endPos = node.selectionEnd;
    const isAlphaNumeric = event.keyCode > 47 && event.keyCode < 91;
    const isnumpad = (event.keyCode > 95 && event.keyCode < 108) || (event.keyCode > 108 && event.keyCode < 112);
    const isSpecialChars = (event.keyCode > 185 && event.keyCode < 193) || (event.keyCode > 218 && event.keyCode < 223);
    const istabKey = event.keyCode === 9;

    if (this.keyboard === 'manglish') {
      if (isAlphaNumeric || isnumpad || isSpecialChars || istabKey) {
        // Precomputed frozen index - same keys/values as MANGLISH_LAYOUT,
        // without the old per-keystroke Object.assign clone of the table.
        this.charMap = MANGLISH_LOOKUP;
        let stepback, pos, chr, range, curLoc, scrollTop;
        const kCode = event.key;
        pos = node.selectionStart;
        chr = istabKey ? '' : kCode;
        if (istabKey) { // Tab key handling
          event.preventDefault();
          this.tabCount++;
          if (this.pattern !== null || this.pattern !== '') {
            if (this.tabCount === 2) {
              this.pattern += this.tabCount;
            } else {
              if (this.charMap[this.pattern.substring(0, this.pattern.length - 1) + this.tabCount]) {
                this.pattern = this.pattern.substring(0, this.pattern.length - 1) + this.tabCount;
              } else {
                this.tabCount = 1;
                this.pattern = this.pattern.substring(0, this.pattern.length - 1);
              }
            }
          }
        } else {
          this.pattern = this.pattern + chr;
        }
        if (this.pattern.length > 5) {
          this.pattern = '';
          this.tabCount = 1;
        }
        if (this.tabCount >= 2) {
          event.preventDefault();
        }
        let malChr = this.charMap[this.pattern];
        if (!malChr) {
          this.pattern = chr;
          this.tabCount = 1;
          this.patternStart = pos;
          malChr = this.charMap[this.pattern];
        }
        this.patternOutput.emit(this.pattern);
        if (malChr) {
          if (this.isExplorer()) {
            range = this.document.selection.createRange();
            stepback = range - this.patternStart;
            range.moveStart('character', -stepback);
            range.text = malChr;
            range.collapse(false);
            range.select();
            return false;
          } else {
            scrollTop = node.scrollTop;
            curLoc = pos;
            stepback = curLoc - this.patternStart;
            node.value = node.value.substr(0, this.patternStart) +
                         malChr +
                         node.value.substr(node.selectionEnd, node.value.length);
            this.minput.emit(node.value);
            node.scrollTop = scrollTop;
            node.selectionStart = curLoc + malChr.length - stepback;
            node.selectionEnd = curLoc + malChr.length - stepback;
            return false;
          }
        } else {
          event.preventDefault();
          node.value = node.value.substring(0, startPos) + chr + node.value.substring(endPos, nodeLen);
          node.focus();
          node.selectionStart = startPos + event.key.length;
          node.selectionEnd = startPos + event.key.length;
          // Scroll position may need to be managed if required
          node.scrollTop = scrollTop;
          this.minput.emit(node.value);
        }
        if (event.keyCode === 9) {
          return false;
        }
        return true;
      } else if (event.keyCode === 8 || event.keyCode === 46) {
        const scrollTop = node.scrollTop;
        event.preventDefault();
        if (window.getSelection().toString()) {
          node.value = node.value.slice(0, startPos) + node.value.slice(endPos, nodeLen);
          node.focus();
          node.selectionStart = startPos;
          node.selectionEnd = startPos;
          node.scrollTop = scrollTop;
        } else {
          node.value = node.value.substring(0, endPos - 1) + node.value.substring(endPos, nodeLen);
          node.focus();
          node.selectionStart = endPos === 0 ? endPos : endPos - 1;
          node.selectionEnd = endPos === 0 ? endPos : endPos - 1;
          node.scrollTop = scrollTop;
        }
        this.pattern = undefined;
        this.patternStart = node.selectionStart;
        this.tabCount = 1;
        this.minput.emit(node.value);
      } else if (event.keyCode === 32) {
        this.pattern = undefined;
      }
      this.patternOutput.emit(this.pattern);
    } else if (this.keyboard === 'english') {
      const scrollTop = node.scrollTop;
      if (isAlphaNumeric || isnumpad || isSpecialChars) {
        event.preventDefault();
        node.value = node.value.substring(0, startPos) + event.key + node.value.substring(endPos, nodeLen);
        node.focus();
        node.selectionStart = startPos + event.key.length;
        node.selectionEnd = startPos + event.key.length;
        node.scrollTop = scrollTop;
        this.minput.emit(node.value);
      } else if (event.keyCode === 8 || event.keyCode === 46) {
        event.preventDefault();
        if (window.getSelection().toString()) {
          node.value = node.value.slice(0, startPos) + node.value.slice(endPos, nodeLen);
          node.focus();
          node.selectionStart = startPos;
          node.selectionEnd = startPos;
          node.scrollTop = scrollTop;
        } else {
          node.value = node.value.substring(0, endPos - 1) + node.value.substring(endPos, nodeLen);
          node.focus();
          node.selectionStart = endPos === 0 ? endPos : endPos - 1;
          node.selectionEnd = endPos === 0 ? endPos : endPos - 1;
          node.scrollTop = scrollTop;
        }
        this.minput.emit(node.value);
      }
    } else if (this.keyboard === 'malayalam') {
      this.handleKeyboardEvent(event);
    }
  }

  /**
   * Commits a suggestion-list alternate (e.g. 'ka3'): replaces the glyph the
   * active pattern wrote with the alternate's glyph - the same splice the
   * Tab-cycle branch of keyDown performs - and re-syncs pattern/tabCount so a
   * following Tab keeps cycling from the committed alternate. Additive API
   * used by ManglishSuggestionComponent's Enter commit; the keydown path is
   * untouched. Returns whether the commit was applied.
   */
  applyAlternate(patternKey: string): boolean {
    if (this.keyboard !== 'manglish' || !this.pattern) {
      return false;
    }
    const currentGlyph = MANGLISH_LOOKUP[this.pattern];
    const nextGlyph = MANGLISH_LOOKUP[patternKey];
    if (currentGlyph === undefined || nextGlyph === undefined) {
      return false;
    }
    // Only alternates of the active pattern's base may be committed.
    if (patternKey.split(/(\d+)/)[0] !== this.pattern.split(/(\d+)/)[0]) {
      return false;
    }
    const node = this.elementRef.nativeElement;
    const scrollTop = node.scrollTop;
    const curLoc = node.selectionStart;
    const stepback = curLoc - this.patternStart;
    node.value = node.value.substr(0, this.patternStart) +
                 nextGlyph +
                 node.value.substr(node.selectionEnd, node.value.length);
    this.minput.emit(node.value);
    node.scrollTop = scrollTop;
    node.selectionStart = curLoc + nextGlyph.length - stepback;
    node.selectionEnd = curLoc + nextGlyph.length - stepback;
    const digits = /(\d+)$/.exec(patternKey);
    this.tabCount = digits ? parseInt(digits[1], 10) : 1;
    this.pattern = patternKey;
    this.patternOutput.emit(this.pattern);
    node.focus();
    return true;
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    const replacements = AppConstants.mlReplacements;
    if (event.keyCode > 46) {
      if (!_.contains(_.range(112, 124), event.keyCode)) {
        event.stopPropagation();
      }
      let text = replacements.get(event.key);
      if (event.keyCode > 95 && event.keyCode < 112) {
        text = event.key;
      }
      if (!!text) {
        event.preventDefault();
        this.insertAtCaretPos(text);
      } else if (!text) {
        this.minput.emit(this.elementRef.nativeElement.value);
      }
    } else if (event.keyCode === 8 || event.keyCode === 46) {
      const node = this.elementRef.nativeElement;
      const nodeLen = node.value.length;
      const startPos = node.selectionStart;
      const endPos = node.selectionEnd;
      const scrollTop = node.scrollTop;
      event.preventDefault();
      if (window.getSelection().toString()) {
        node.value = node.value.slice(0, startPos) + node.value.slice(endPos, nodeLen);
        node.focus();
        node.selectionStart = startPos;
        node.selectionEnd = startPos;
        node.scrollTop = scrollTop;
      } else {
        node.value = node.value.substring(0, endPos - 1) + node.value.substring(endPos, nodeLen);
        node.focus();
        node.selectionStart = endPos === 0 ? endPos : endPos - 1;
        node.selectionEnd = endPos === 0 ? endPos : endPos - 1;
        node.scrollTop = scrollTop;
      }
      this.minput.emit(node.value);
    }
  }

  insertAtCaretPos(text: string) {
    const document = this.document;
    const node = this.elementRef.nativeElement;
    const nodeLen = node.value.length;
    if (document.selection) {
      node.focus();
      const sel = document.selection.createRange();
      sel.text = text;
      node.focus();
    } else if (node.selectionStart || node.selectionStart === 0) {
      const startPos = node.selectionStart;
      const endPos = node.selectionEnd;
      const scrollTop = node.scrollTop;
      const prev = node.value[startPos - 1];
      if ((prev === '\u0d1a' || prev === '\u0d2f' || prev === '\u0d2c' || prev === '\u0d35') && text === '\u0d52') {
        node.value = this.repStrByidx(startPos - 1, node.value, '\u200D');
        text = prev + '\u0d4d' + prev;
      } else if (text === '\u0d52') {
        text = '';
      }
      node.value = node.value.substring(0, startPos) + text + node.value.substring(endPos, nodeLen);
      node.focus();
      node.selectionStart = startPos + text.length;
      node.selectionEnd = startPos + text.length;
      node.scrollTop = scrollTop;
    } else {
      node.value += text;
      node.focus();
      node.value = node.value; // forces cursor to end
    }
    this.minput.emit(node.value.length ? node.value : '');
  }

  repStrByidx(index: number, value: string, replacement: string) {
    return value.substr(0, index) + replacement + value.substr(index + replacement.length);
  }

  isExplorer() {
    return (this.document.selection && this.document.selection.createRange().isEqual);
  }
}
